import { Stack, Typography } from "@mui/material";
import React from "react";
import InfoIcon from "@mui/icons-material/Info";

interface IProps {
  info: string;
}
const MarketTreeMapInfo = ({ info }: IProps) => {
  return (
    <Stack direction="row" justifyContent="flex-start" alignItems="flex-start" spacing={0.5} mt={1}>
      <InfoIcon sx={{ height: "15px", width: "15px" }} />
      <Typography sx={{ fontSize: "12px" }}>{info}</Typography>
    </Stack>
  );
};

export default MarketTreeMapInfo;
